<script setup>
import SearchDialog from '~/components/SearchDialog.vue'

const head = useLocaleHead()
const showFooterState = useState('showFooter')
showFooterState.value = true
</script>
<template>
  <Html :lang="head.htmlAttrs.lang" :dir="head.htmlAttrs.dir">
  <Head>
    <template v-for="link in head.link" :key="link.hid">
      <Link :id="link.hid" :rel="link.rel" :href="link.href" :hreflang="link.hreflang"/>
    </template>
    <template v-for="meta in head.meta" :key="meta.hid">
      <Meta :id="meta.hid" :property="meta.property" :content="meta.content"/>
    </template>
  </Head>
  <Body class="bg-white dark:bg-[#121212] text-black dark:text-white">
    <MainHeader/>
    <slot/>
    <MainFooter v-if="showFooterState" />
    <SearchDialog />
  </Body>
  </Html>
</template>
